import { useState } from "react";
import { useNavigate, Navigate, useSearchParams } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Only allow safe internal relative paths as ?next targets
const safeNext = (v) => (v && v.startsWith("/") && !v.startsWith("//") ? v : "/admin");

const AdminLogin = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const next = safeNext(params.get("next"));

  if (typeof window !== "undefined" && localStorage.getItem("admin_token")) {
    return <Navigate to={next} replace />;
  }

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await axios.post(`${API}/auth/login`, { username, password });
      localStorage.setItem("admin_token", data.token);
      navigate(next, { replace: true });
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Login failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[var(--bg)] text-[var(--ink)] flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-md">
        <div className="overline mb-3">— Admin</div>
        <h1 className="font-display text-5xl mb-8 tracking-tight">Sign in.</h1>

        <form onSubmit={submit} className="border border-black/20 p-6 bg-white/40 backdrop-blur-sm" data-testid="admin-login-form">
          <label className="block mb-5">
            <span className="overline block mb-2">Username</span>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              autoFocus
              className="w-full bg-transparent border-b border-black/40 focus:border-black outline-none py-2 text-lg font-medium"
              data-testid="admin-login-username"
            />
          </label>
          <label className="block mb-6">
            <span className="overline block mb-2">Password</span>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full bg-transparent border-b border-black/40 focus:border-black outline-none py-2 text-lg font-medium"
              data-testid="admin-login-password"
            />
          </label>

          {error && (
            <div className="mb-4 text-sm text-red-700" data-testid="admin-login-error">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="cta-pill disabled:opacity-60"
            data-testid="admin-login-submit"
          >
            <span>{loading ? "Signing in…" : "Sign in"}</span>
          </button>
        </form>

        <a href="/" className="block mt-6 overline link-underline">← Back to site</a>
      </div>
    </div>
  );
};

export default AdminLogin;
